import { createRoot } from 'react-dom/client';

import browser from '@openclassrooms/utils/browser';
import AppProviders from 'Modules/webapp/components/AppProviders';
import TextareaCounterFromDom, { DIRECTIVE_VALUE } from './components/TextareaCounterFromDom';

function createAndInsertSpan(target) {
  const span = browser.document.createElement('span');
  target.parentNode.insertBefore(span, target);

  return span;
}

function createTextareaCounterComponent(textarea) {
  const span = createAndInsertSpan(textarea);

  const root = createRoot(span);
  root.render(
    <AppProviders productionPrefix="textarea-counter">
      <TextareaCounterFromDom textarea={textarea} />
    </AppProviders>
  );

  textarea.parentNode.removeChild(textarea);
}

function textareaCounter() {
  const textareas = [
    ...browser.document.querySelectorAll(`textarea[data-component="${DIRECTIVE_VALUE}"]`),
  ];
  textareas.forEach(createTextareaCounterComponent);
}

export default textareaCounter;
